import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import addVisibilityObserver from '@/js/components/useVisibilityObserver';
import BaseComponent from './baseComponent';

gsap.registerPlugin(ScrollTrigger);

export default class TeaserMultipleLarge extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);
    this.el = document.querySelector('[data-teaser-multiple-large]');

    if (this.el) {
      this.debug = false;
      this.introText = this.el.querySelector('.intro > .intro-text');
      this.products = this.el.querySelectorAll('.product');
    }
  }

  init() {
    if (!this.el) {
      return;
    }

    if (document.querySelector('[data-goal-based-advisory-intro]')) {
      setTimeout(() => {
        addVisibilityObserver(this.el, {
          onFirstEnter: () => {
            console.log('ContentFullBackground initialised after GoalBasedAdvisoryIntro');
            this.animation();
          },
        }, {
          // rootMargin: '-500px',
          threshold: 0,
        });
      }, 1000);
    } else {
      addVisibilityObserver(this.el, {
        onFirstEnter: () => {
          console.log('ContentFullBackground initialised');
          this.animation();
        },
      }, {
        // rootMargin: '-500px',
        threshold: 0,
      });
    }
  }

  animation() {
    // create match media queries
    const mm = gsap.matchMedia();

    // following scroll-animation only runs on viewport large
    mm.add('(min-width: 992px)', () => {
      this.products.forEach((product) => {
        const illustration = product.querySelector('.illustration');

        const startPosition = 'top 60%'; // default position

        // define unique start position based on the product index
        // if (index === 0) {
        //   startPosition = 'top-=55% top'; // specific for the first product
        // } else if (index === 1) {
        //   startPosition = 'top-=15% top'; // specific for the second product
        // }

        const productTl = gsap.timeline({
          scrollTrigger: {
            trigger: product,
            start: startPosition,
            scrub: true,
            end: 'bottom bottom',
            markers: this.debug,
          },
        });

        productTl
          .to(illustration, { scale: 1.1 });
      });
    });
  }
}
